const state = () => ({
    simpleSearch: {
      id: "",
      name: ""
    },
    simpleSearchKeys: ["id", "name"],
    pagination: {
        page: 1,
        limit: 10,
        pageOptions: [10, 25, 50, 100]
    },
    states: {
        searching: false,
        hasError: false,
        showSuccess: false,
        hasCleared: false
    },
    items: [],
    errorMessage: null,
  });
  
  const getters = {
  };
  
  const mutations = {
    updateStates(state, payload) {
      _.merge(state.states, payload);
    },
    setItems(state, items) {
      state.items = items;
    },
    setErrorMessage(state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    setPage(state, page) {
      state.pagination.page = page;
  
      // Trigger Search
      state.states.searching = true;
    },
    setLimit(state, limit) {
      state.pagination.limit = limit;
      state.pagination.page = 1;
  
      // Trigger Search
      state.states.searching = true;
    },
    resetSearch(state, payload) {
      // Trigger Search
      state.simpleSearch.id = state.simpleSearch.name;
      state.states.searching = true;
    },
    updateSimpleSearchValue(state, payload) {
      state.searching = true;
      state.simpleSearch[payload.key] = payload.value;
      if (payload.value.length < 1) {
        state.states.hasCleared = true;
      }
    },
  };
  
  export default {
      state,
      getters,
      mutations,
      namespaced: true,
  }